import React from 'react';
import { useLocation } from 'react-router-dom';
import { ExternalLink } from 'react-feather';
import { CLIO_TEMPLATES_STRING, GENERAL_TEMPLATE_FILTER } from './constants';
import ClioTemplatesPracticeAreaCard from './ClioTemplatesPracticeAreaCard';
import { getRegion, Region } from '~/src/regions/config/utils';

interface ClioTemplatesSectionProps {
  primaryPracticeArea?: string;
  secondaryPracticeArea?: string;
  primaryState?: string;
}

const ClioTemplatesSection: React.FC<ClioTemplatesSectionProps> = ({
  primaryPracticeArea,
  secondaryPracticeArea,
  primaryState,
}) => {
  const location = useLocation();
  const isQuestionnairesRoute = location.pathname.includes('/questionnaires/');
  const showExchangeLink = !isQuestionnairesRoute && getRegion() === Region.US;
  let currentPath = location.pathname;
  if (!currentPath.endsWith('/')) {
    currentPath = currentPath + '/';
  }

  return (
    <div
      className="bg-white border border-gray-200 rounded-lg p-6 mb-6 mx-auto"
      style={{ width: '100%', maxWidth: '1080px' }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">{CLIO_TEMPLATES_STRING}</h3>
        {showExchangeLink && (
          <a
            href="https://exchange.lawyaw.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 text-sm font-medium cursor-pointer flex items-center gap-1"
          >
            View all templates
            <ExternalLink size={14} />
          </a>
        )}
      </div>
      <p className="text-600 text-sm mb-3">
        Get started with over 1000 templates from a variety of practice areas
        and jurisdictions. <br></br>Use them &quot;out-of-the-box&quot; or
        customize them to your practice.
      </p>
      <div>
        {primaryState && (
          <div className="mb-4">
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Available for your practice
            </span>
            <h5 className="text-lg font-semibold mb-2">{primaryState}</h5>
          </div>
        )}
        <div className="flex gap-3">
          <ClioTemplatesPracticeAreaCard
            label="General"
            to={`${currentPath}clio?practiceArea=${GENERAL_TEMPLATE_FILTER}`}
          />
          {primaryPracticeArea && (
            <ClioTemplatesPracticeAreaCard
              label={primaryPracticeArea}
              to={`${currentPath}clio?practiceArea=${primaryPracticeArea}`}
            />
          )}
          {secondaryPracticeArea && (
            <ClioTemplatesPracticeAreaCard
              label={secondaryPracticeArea}
              to={`${currentPath}clio?practiceArea=${secondaryPracticeArea}`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ClioTemplatesSection;
